import React, { FormEvent, useContext, useEffect, useState } from "react";
import { Grid, Segment, Form, Button, Popup } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import UnifyJobsStore from "../../../app/stores/unifyjobsStore";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import { CSVLink } from "react-csv";
import EmployeeUnifyJobList from "./EmployeeUnifyJobList";

const EmployeeUnifyJobDashboard: React.FC = () => {
  const unifyJobStore = useContext(UnifyJobsStore);
  const {
    submitting,
    searchUnifyJobs,
    loadPayrollCycles,
    payrollcyclesByName,
    payrollcycleRegistry,
    unifyjobnamesByDate,
    unifyjobRegistry
  } = unifyJobStore;

  useEffect(() => {
    loadPayrollCycles();
    unifyjobRegistry.clear();
  }, []);

  const [search, setSearch] = useState({
    tech: "portal",
    payRun: "",
    jobStartDate: "",
    jobEndDate: "",
    workNo: "",
  });

  if (unifyJobStore.loadingInitial)
    return <LoadingComponent content="Loading UnifyJob" />;

  const payrunOptions = payrollcyclesByName.map(function (payrun) {
    var option = {
      key: payrun.startYear + payrun.endYear + payrun.payRun,
      text: payrun.startYear + "-" + payrun.endYear + " " + payrun.payRun,
      value: payrun.startYear + "-" + payrun.endYear + "-" + payrun.payRun,
    };
    return option;
  });

  const handleSubmit = () => {
    searchUnifyJobs(search);
  };

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setSearch({ ...search, [name]: value });
  };

  return (
    <Segment>
      <Form onSubmit={handleSubmit}>
        <Grid columns={2}>
          <Grid.Column>
            <Form.Select
              label="Pay Run"
              onChange={(e, { name, value }) =>
                setSearch({ ...search, [name]: value })
              }
              options={payrunOptions}
              search
              name="payRun"
              placeholder="Pay Run"
              value={search.payRun}
              clearable
            />
          </Grid.Column>
          <Grid.Column>
            <div style={{ marginTop: "1rem" }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              {payrollcycleRegistry.get(search.payRun) &&
                "From:\xa0\xa0" +
                  payrollcycleRegistry
                    .get(search.payRun)
                    .startDate.substr(0, 10)}
            </div>
            <div>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              {payrollcycleRegistry.get(search.payRun) &&
                "To:\xa0\xa0" +
                  payrollcycleRegistry.get(search.payRun).endDate.substr(0, 10)}
            </div>
          </Grid.Column>
        </Grid>
        <Grid columns={2}>
          <Grid.Column>
            <Form.Input
              label="Job Start Date"
              onChange={handleInputChange}
              name="jobStartDate"
              type="date"
              placeholder="Date"
              clearable
              value={search.jobStartDate}
            />
          </Grid.Column>
          <Grid.Column>
            <Form.Input
              label="Job End Date"
              onChange={handleInputChange}
              name="jobEndDate"
              type="date"
              placeholder="Date"
              clearable
              value={search.jobEndDate}
            />
          </Grid.Column>
        </Grid>
        <Grid columns={2}>
          <Grid.Column>
            <Form.Input
              label="Work Order No."
              onChange={handleInputChange}
              name="workNo"
              placeholder="Work Order No."
              value={search.workNo}
            />
          </Grid.Column>
          <Grid.Column>
            <Button
              loading={submitting}
              floated="left"
              positive
              type="submit"
              content="Search"
              style={{ marginTop: "1.5rem" }}
            />
          </Grid.Column>
        </Grid>
      </Form>
      <CSVLink data={unifyjobnamesByDate} filename={"unifyjoblist.csv"}>
        <Popup
          content="Download as CSV"
          trigger={
            <Button
              icon="download"
              floated="right"
              style={{ marginTop: "-3rem" }}
            />
          }
        />
      </CSVLink>
      <EmployeeUnifyJobList />
    </Segment>
  );
};

export default observer(EmployeeUnifyJobDashboard);
